export default __webpack_public_path__ + "assets/models/draco/Field.glb";